"use strict";

exports.__esModule = true;
var _ThresholdPicker = require("./ThresholdPicker");
Object.keys(_ThresholdPicker).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ThresholdPicker[key]) return;
  exports[key] = _ThresholdPicker[key];
});
var _ThresholdGradientPreview = require("./ThresholdGradientPreview");
Object.keys(_ThresholdGradientPreview).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ThresholdGradientPreview[key]) return;
  exports[key] = _ThresholdGradientPreview[key];
});